import { useParams } from "react-router-dom";

import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";
import ImgUrl from 'assets/images/brand.png';

import {pageMenuTabList05} from "types/common";

import 'assets/css/brand.scss';

function Representative() {
  const { brandId } = useParams<{ brandId: string }>();

  pageMenuTabList05[1].on = true;

  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/news-hero_1920x1080.jpg.jpg" imgText="대표제품" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList05} />
      
      <div className="brand container">
        <h1>Representative {brandId}</h1>
      </div>
    </div>
  );
}

export default Representative;
